<template>
     <transition v-if="showModal">
        <div class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5">
            <div class="bg-white w-52 border-[1px] border-primary rounded-[4px] px-4 py-4">
                <button class="float-right" @click="closeModal()">
                    <Icon name="Fechar"/>
                </button>
                <div>
                    <h1>Status Regionais</h1>
                    <ul>
                        <li v-for="region in regionalStatus" :key="region.id" class="flex items-center gap-x-2"><div class="w-2 h-2 rounded-full" :class="region.status ? 'bg-success' : 'bg-error'"></div> {{region.name}}</li>
                    </ul>
                </div>
                <!-- <h1 class="text-[20px] font-bold text-primary">{{$page.props.flash.success?.title}}</h1> -->
            </div>
        </div>
    </transition>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue';
export default {
    components: {
        Icon
    },
    emits: ['closeModal'],
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        currentRegionalStatus: {
            type: Array,
            default: false
        },
        currentAvailableRegions: {
            type: Array,
            default: false
        }
    },
    data() {
        return {
            regions: [
                {id: 1, name: 'MG + CO'},
                {id: 2, name: 'NE'},
                {id: 3, name: 'NO'},
                {id: 4, name: 'RJ + ES'},
                {id: 5, name: 'SPI'},
                {id: 6, name: 'SPL'},
                {id: 7, name: 'SPS'},
                {id: 8, name: 'SUL'},
            ],
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal');
        }
    },
    computed: {
        regionalStatus() {
            console.log({
                regions: this.regions,
                currentAvailableRegions: this.currentAvailableRegions,
            })
            return this.regions
                .filter(region => this.currentAvailableRegions.find(available => region.name === available.name))
                .map(region => ({...region, status: Boolean(this.currentRegionalStatus.find(current => current.regionName === region.name))}))
        }
    }
}
</script>
